import React from 'react'
import Hero from "../Hero"
import About from './Content/About/About';
import Register from './Content/Register';
import Background from "../../assets/images/hero/employers.jpg"

function EmployerPage() {
    // If have employer handbook. Uncomment this and pass to Hero.
    // const button = (
    //     <button type="button" className="btn btn-primary btn-lg">
    //         <a href={process.env.PUBLIC_URL + "/pdf/Employer_Handbook.pdf"}>Download Handbook</a>
    //     </button>
    // )
    return (
        <div>
            <Hero title="Organisation Home" heroImage={Background} />
            <About/>
            <Register/>
        </div>
    )
}

export default EmployerPage;
